import * as yup from 'yup';

export const newUserSchema = (emailError, emailRequired, roleRequired) =>
  yup.object().shape({
    email: yup.string().email(emailError).required(emailRequired),
    role: yup.number().required(roleRequired),
  });
